export enum IOrderFields {
    Name = 'Name',
    Term = 'MandateStartDate',
    Image = 'Image',
}

export interface IDeleteUserForm {
    entityId?: number;
}
